import { memo } from 'react';

interface TimezoneRowProps {
    iso: string;
    showName: string;
    offset: number;
    isSelected: boolean;
    onClick: () => void;
}

const TimezoneRowComponent = ({ iso, showName, offset, isSelected, onClick }: TimezoneRowProps) => {
    const formattedOffset = offset > 0 ? `+${offset}` : `${offset}`;

    return (
        <button
            type='button'
            onClick={onClick}
            className={`flex w-full cursor-pointer items-center gap-1.5 rounded-md px-3 py-2.5 text-left transition-colors ${
                isSelected
                    ? 'bg-brand-subtle text-primary-fg text-label-sm-bold'
                    : 'text-label-sm-regular text-neutral-fg hover:bg-neutral-hover'
            }`}
        >
            <span className='text-dark shrink-0 font-semibold'>{iso}&nbsp;-</span>
            <span className='text-dark min-w-0 flex-1 truncate'>{showName}</span>
            <span className='text-light shrink-0'>|&nbsp;UTC&nbsp;{formattedOffset}</span>
        </button>
    );
};

export const TimezoneRow = memo(TimezoneRowComponent);
